import React from 'react';

export function CloseIcon({ height, width, className = '' }: sharedComponents.SvgIcon) {
  return <svg width={`${width}px`} height={`${height}px`} viewBox="0 0 21 21" version="1.1">
    <title>CloseIcon</title>
    <desc>Close icon</desc>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g className={className} fill="#6400AA">
        <path
          d="M17.3059032,2.45666036 L18.5433401,3.69409723 L11.7366604,10.4996604 L18.5433396,17.3059032 L17.3059028,18.5433401 L10.4996604,11.7366604 L3.69409765,18.5433396 L2.45666078,17.3059028 L9.26266045,10.4996604 L2.45666036,3.69409765 L3.69409723,2.45666078 L10.4996604,9.26266045 L17.3059032,2.45666036 Z" // eslint-disable-line
        />
      </g>
    </g>
  </svg>;
}
